import store from '@/store/index'
import { userInfo } from '@/services/module/user'

export default async function ajaxInit() {
  try {
    const {
      data: { data, errCode }
    } = await userInfo({ _cache_bust: Date.now() }, false)
    if (errCode != 0) {
      await store.dispatch('user/clearToken', false)
      return 1
    }
    if (data) {
      const promoteCode = data.promote_code || ''
      const subChannelId = data.sub_channel_id || ''
      await store.dispatch('channelAttributionChange', { promoteCode, subChannelId })
      await store.dispatch('user/updateUserInfo', data)
      await store.dispatch('user/updateToken', data?.token)
    }
  } catch (e) {
    console.log(e)
    return 2
  } finally {
    await store.dispatch('user/doenAjaxInit', true)
  }
}
